import Http from "./http";

export const welcomeEmailTemplateListAPI = (data) => {
  return Http.post(`admin/email-templates/getTemplateByEventType`,data);
};
